<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4 text-truncate">Add New B2B Customer {{ (this.customer.first_name) ? (" - " + this.customer.first_name) : "" }} </h6>
        <h6 v-else-if="profileId != 0 && $attrs.viewMode == true" class="heading-small text-muted mb-4 text-truncate">View B2B Customer {{ (this.customer.first_name) ? (" - " + this.customer.first_name) : "" }}</h6>
        <h6 v-else class="heading-small text-muted mb-4 text-truncate">Edit B2B Customer {{ (this.customer.first_name) ? (" - " + this.customer.first_name) : "" }}</h6>

        <base-alert v-if="errors.length" type="danger">
            <button type="button" class="close" aria-label="Close" @click="errors = []">
              <span aria-hidden="true">&times;</span>
            </button>
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li> 
        </base-alert>

    
        <div class="row mt-3">
            <div class="col-md-3">
                <a-steps :current="current" direction="vertical" @change="onChange" progress-dot>
                  <a-step v-for="item in steps" :key="item.title" :title="item.title" />
                </a-steps>
            </div>

            <div class="steps-content col-md-9" >
                <!-- FORM HERE -->
                <a-spin :spinning="spinning">
                <form id="form-proper">
                    <div v-if="customFormMode == 1 || customFormMode == 3">

                        <div v-if="current == 0" class="row">
                            <div class="col-md-12">
                                <base-input label="Code">
                                    <a-input :disabled="viewMode" type="text" v-model="customer.code"/>
                                </base-input>

                                <base-input label="Name" required>
                                    <a-input :disabled="viewMode" type="text" v-model="customer.name"/>
                                </base-input>

                                <base-input label="Customer Type">
                                    <a-select   showSearch
                                        v-model="customer.customer_type"
                                        style="width: 100%" placeholder="Please select"
                                        :filterOption="false"
                                        :notFoundContent="fetching ? undefined : null"
                                        :disabled="viewMode"
                                        @search="handleCusTypeSearch"
                                        @focus="handleCusTypeSearch"
                                    >
                                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                        <a-select-option v-for="option in customerTypes" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input>

                                <base-input label="Customer Type" class="d-none">
                                    <a-select v-model="customer.customer_type_name" showSearch placeholder="Select Customer Type" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="viewMode">
                                        <a-select-option v-for="option in customerTypeNames" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                    </a-select>
                                </base-input>

                                <base-input label="Business Style">
                                    <a-input :disabled="viewMode" type="text" v-model="customer.business_style_name"/>
                                </base-input>


                                <base-input label="Payment Terms">
                                    <a-select   showSearch
                                                v-model="customer.payment_term"
                                                style="width: 100%" placeholder="Please select"
                                                :filterOption="false"
                                                :notFoundContent="fetching ? undefined : null"
                                                :disabled="viewMode"
                                                @search="handlePaymentTermSearch"
                                                @focus="handlePaymentTermSearch"
                                    >
                                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                        <a-select-option v-for="option in paymentTerms" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input>

                                <base-input label="TIN Number">
                                    <a-input :disabled="viewMode" type="text" v-model="customer.tin"/>
                                </base-input>

                                <base-input label="Credit Limit">
                                    <a-input type="text" v-model="customer.credit_limit"/>
                                </base-input>

                                <base-input label="Credit Balance">
                                    <a-input type="text" v-model="customer.credit_balance"/>
                                </base-input>

                                <base-input label="Vat Type">
                                    <a-select :disabled="viewMode" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="customer.vat_type">
                                        <a-select-option v-for="option in vatTypeOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                    </a-select>
                                </base-input>

                                <base-input label="WTax Code">
                                    <a-select   showSearch
                                        v-model="customer.wtax_code"
                                        style="width: 100%" placeholder="Please select"
                                        :filterOption="false"
                                        :notFoundContent="fetching ? undefined : null"
                                        :disabled="viewMode"
                                        @search="handleWtaxesSearch"
                                        @focus="handleWtaxesSearch"
                                    >
                                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                        <a-select-option v-for="option in wtaxCodes" :key="option.id" :value="option.w_tax_code">{{option.w_tax_code}} - {{parseFloat(option.percentage * 100).toFixed(2)}}%</a-select-option>
                                    </a-select>
                                </base-input>

                                <base-input label="Credit On Hold" >
                                    <base-checkbox disabled class="col-md-12"  v-model="customer.is_on_hold">
                                        Credit On Hold
                                    </base-checkbox>
                                </base-input>

                                <base-input label="Status" >
                                    <base-checkbox :disabled="viewMode" class="col-md-12"  v-model="is_active">
                                        Active
                                    </base-checkbox>
                                </base-input>

                            </div>
                        </div>

                        <div v-if="current == 1" class="row">
                            <div class="col-md-12">
                                <base-input label="First Name" required>
                                    <a-input :disabled="viewMode" type="text" v-model="customer.first_name"/>
                                </base-input>

                                <base-input label="Middle Name" required>
                                    <a-input :disabled="viewMode" type="text" v-model="customer.middle_name"/>
                                </base-input>

                                <base-input label="Last Name" required>
                                    <a-input :disabled="viewMode" type="text" v-model="customer.last_name"/>
                                </base-input>

                                <base-input label="Birthday" >
                                <br/>
                                <a-date-picker :disabled="viewMode" :disabled-date="disabledDate" v-model="customer.birthday" :format="dateFormat" style="width: 100%;"/>
                                </base-input>

                                <base-input label="Mobile">
                                    <small class="ml-1"> (e.g. +639123456789)</small>
                                    <a-input :disabled="viewMode" type="text" v-model="customer.mobile" addonBefore="+" />
                                </base-input>

                                <!-- <base-input label="Address">
                                    <a-input :disabled="viewMode" type="text" v-model="customer.address"/>
                                </base-input> -->

                                <base-input label="Telephone">
                                    <a-input :disabled="viewMode" type="text" v-model="customer.telephone"/>
                                </base-input>

                                <base-input label="Fax">
                                    <a-input :disabled="viewMode" type="text" v-model="customer.fax"/>
                                </base-input>

                                <base-input label="Email">
                                    <a-input :disabled="viewMode" type="text" v-model="customer.email" />
                                </base-input>

                                <base-input label="Gender" >
                                    <a-select :disabled="viewMode" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="customer.gender">
                                        <a-select-option key="F" value="F">FEMALE</a-select-option>
                                        <a-select-option key="M" value="M">MALE</a-select-option>
                                    </a-select>
                                </base-input>

                                <base-input label="Civil Status" >
                                    <a-select :disabled="viewMode" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="customer.civil_status">
                                        <a-select-option v-for="option in civilOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                    </a-select>
                                </base-input>

                            </div>
                        </div>

                        <div v-if="current == 2" class="row">
                            <div class="col-md-12">
                                <!-- <base-input class="col-md-12" label="Country">
                                    <a-select   showSearch
                                                v-model="customer.address.country_id"
                                                style="width: 100%" placeholder="Please select"
                                                :filterOption="false"
                                                :notFoundContent="fetching ? undefined : null"
                                                :disabled="viewMode"
                                                @search="handleCountrySearch"
                                                @focus="handleCountrySearch"
                                                @change="changeAddress('provinces')"
                                    >
                                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                        <a-select-option v-for="option in countries" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input> -->

                                <base-input class="col-md-12" label="Zip Code">
                                    <a-input :disabled="viewMode" type="text" v-model="customer.address.zip_code"/>
                                </base-input>

                                <base-input class="col-md-12" label="Address 1">
                                    <a-input :disabled="viewMode" type="text" v-model="customer.address.address"/>
                                </base-input>

                                <!-- <base-input class="col-md-12" label="Region">
                                    <a-select v-model="customer.address.region_code" showSearch placeholder="Select Region" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('provinces')" :disabled="addressLoading == true || viewMode">
                                        <a-select-option v-for="option in addressOptions.regions" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input> -->

                                <base-input class="col-md-12" label="Country">
                                    <a-select v-model="customer.address.country_id" showSearch placeholder="Select Country" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('provinces')" :disabled="addressLoading == true || viewMode">
                                        <a-select-option v-for="option in countries" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input>

                                <base-input class="col-md-12" label="Province">
                                    <a-select v-model="customer.address.province_code" showSearch placeholder="Select Province" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('cities')" :disabled="addressLoading == true || viewMode">
                                        <a-select-option v-for="option in addressOptions.provinces" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input>

                                <base-input class="col-md-12" label="City">
                                    <a-select v-model="customer.address.city_code" showSearch placeholder="Select City" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('barangays')" :disabled="addressLoading == true || viewMode">
                                        <a-select-option v-for="option in addressOptions.cities" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input>

                                <base-input class="col-md-12" label="Barangay">
                                    <a-select v-model="customer.address.barangay_code" showSearch placeholder="Select Barangay" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('none')" :disabled="addressLoading == true || viewMode">
                                        <a-select-option v-for="option in addressOptions.barangays" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input>

                            </div>
                        </div>

                        <div v-if="current == 3" class="row">
                            <dynamic-form :convertedJson="{mode: 'list', groups: customForm.groups_append}" :formSettings="this.customer" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                        </div>

                    </div>
                </form>
            </a-spin>
            </div>
        </div>

        <div  style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
            <div class="steps-action float-right">
                <button v-if="current>0" style="margin-left: 8px" @click="current--" class="btn btn-sm btn-primary">
                  Previous
                </button>
                <button v-if="current < steps.length - 1" type="primary" @click="current++" class="btn btn-sm btn-primary">
                  Next
                </button>
                <button
                  class="btn btn-sm btn-success"
                  v-if="current == steps.length - 1 && isEditing == true"
                  type="primary"
                  @click.prevent="done"
                >
                  Done
                </button>
            </div>
        </div>
    
    </div>

</template>

<script>

import HTTPRequest from '../../controllers/httpRequest.js'
import secureStorage from '../../controllers/secureStorage.js'
import ValidateField from '../../components/validateFormUtils.js'
import DynamicForm from '../DynamicForm.vue'

import { mapState } from 'vuex'
import axios from "axios";
import moment from 'moment';
import { decrypt } from "../../utilities.js"

var component_x;

export default {
    components: {
            DynamicForm
    },
    data() {
        return {
            countries: [],
            provinces: [],
            cities: [],
            barangays: [],
            spinning: false,
            dynamicFormKey: 0,
            viewMode: false,
            customFormMode: 1,
            customForm: {},
            customer: {
                status: 'A',
                address: {
                    region_code: null,
                    region_name: "",
                    province_code: null,
                    province_name: "",
                    city_code: null,
                    city_name: "",
                    barangay_code: null,
                    barangay_name: "",
                    country_id: null,
                    zip_code: null,
                    address:null,
                },
            },
            addressOptions: {
                regions: [],
                provinces: [],
                cities: [],
                barangays: []
            },
            addressLoading: false,
            is_active: true,
            // Form
            vatTypeOptions: [
                    {key: "V", value: "VATable"},
                    {key: "X", value: "VAT-exempt"},
                    {key: "Z", value: "Zero-rated"}
            ],
            dateFormat: 'MM-DD-YYYY',
            current: 0,
            steps: [
                { title: 'Basic Info' },
                { title: 'Contact Details'},
                { title: 'Address'},
            ], 
            customerTypeNames: [
                {key: 'company',value: 'Company'},
                {key: 'individual',value: 'Individual'},
            ],
            civilOptions: [
                    // {key: null, value: null},
                    {key: "S", value: "SINGLE"},
                    {key: "M", value: "MARRIED"},
                    {key: "W", value: "WIDOWER"}
            ],
            // UPLOADER
            previewVisible: false,
            previewImage: '',
            fileList: [],
            imageLoaded: true,
            authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"  },
            errors: [],
            dynamicFormErrors: [],
            response: [],

            // searchable select
            fetching: false,
            customerTypes: [],
            paymentTerms: [],
            wtaxCodes: [],

            securedSync: false,
            showSensitiveInfo: false,
            isEditing: false,
        }
    },
    computed: {
        ...mapState(['endPoint', 'profileId', 'serverType', 'publicUrl']),
    },
    mounted: async function(){
        this.spinning = true;
        //this.viewMode = this.serverType == 'branch' || this.$attrs.viewMode == true;
        if(this.$attrs.viewMode == false)
            this.isEditing = true;
        this.viewMode = true;
        var countries = await HTTPRequest.getRequest(this.endPoint + "countries" , null, null)
        this.countries = countries.data
        component_x = this

        this.securedSync = false

        const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/B2B Customer?field_name=name'  , null)
        const sytemModuleId = sytemModule.id
        const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)

        if(this.isJsonString(accSystemModuleRequest.meta) == true){

            const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
            if(accSystemModule != null){
                if(accSystemModule.form_mode != undefined){
                    this.customFormMode = accSystemModule.form_mode
                }

                if(this.customFormMode == 3){
                    this.steps.push({title: "Custom Fields"})
                }

                if(this.customFormMode == 2){
                    this.steps = [ {title: "Main Form"}, {title: "Consent"}]
                }

                if(accSystemModule.customized_forms != undefined){
                    this.customForm = accSystemModule.customized_forms
                }
            }
        }
        //await this.changeAddress('regions', 1);
        await this.changeAddress('provinces', 1);
        if (this.profileId > 0) {
                var customer_data = await HTTPRequest.getRequest(component_x.endPoint + 'b2b_customers/' + this.profileId, null)
                this.customerData = customer_data
                if (customer_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (customer_data["error"] == undefined) {
                        this.customer = customer_data
                        this.customer.address = {
                        region_code: customer_data["region_code"],
                        region_name: customer_data["region_name"],
                        province_code: customer_data["province_code"],
                        province_name: customer_data["province_name"],
                        city_code: customer_data["city_code"],
                        city_name: customer_data["city_name"],
                        barangay_code: customer_data["barangay_code"],
                        barangay_name: customer_data["barangay_name"],
                        zip_code: customer_data["zip_code"],
                        country_id: customer_data["country_id"],
                        address: customer_data["address"]
                    }
                        if (this.customer.first_name!=undefined && this.customer.first_name != "" && this.customer.first_name != null) this.customer.first_name = decrypt(this.customer.first_name) 
                        if (this.customer.middle_name!=undefined && this.customer.middle_name != "" && this.customer.middle_name != null) this.customer.middle_name = decrypt(this.customer.middle_name) 
                        if (this.customer.last_name!=undefined && this.customer.last_name != "" && this.customer.last_name != null) this.customer.last_name = decrypt(this.customer.last_name) 
                        if (this.customer.last_name!=undefined && this.customer.last_name != "" && this.customer.last_name != null) this.customer.last_name = decrypt(this.customer.last_name) 
                        if (this.customer.civil_status!=undefined && this.customer.civil_status != "" && this.customer.civil_status != null) this.customer.civil_status = decrypt(this.customer.civil_status) 
                        if (this.customer.birthday!=undefined && this.customer.birthday != "" && this.customer.birthday != null) this.customer.birthday = decrypt(this.customer.birthday) 
                        if (this.customer.religion!=undefined && this.customer.religion != "" && this.customer.religion != null) this.customer.religion = decrypt(this.customer.religion) 
                        if (this.customer.mobile!=undefined && this.customer.mobile != "" && this.customer.mobile != null) this.customer.mobile = decrypt(this.customer.mobile) 
                        if (this.customer.telephone!=undefined && this.customer.telephone != "" && this.customer.telephone != null) this.customer.telephone = decrypt(this.customer.telephone) 
                        if (this.customer.email!=undefined && this.customer.email != "" && this.customer.email != null) this.customer.email = decrypt(this.customer.email) 
                        if (this.customer.tin!=undefined && this.customer.tin != "" && this.customer.tin != null) this.customer.tin = decrypt(this.customer.tin) 
                        if (this.customer.name!=undefined && this.customer.name != "" && this.customer.name != null) this.customer.name = decrypt(this.customer.name) 

                        this.customer.credit_limit = this.formatMyNumber(customer_data['credit_limit'], 2)
                        this.customer.credit_balance = this.formatMyNumber(customer_data['credit_balance'], 2)
                        
                        if(this.customer.status == 'A'){
                            this.is_active = true
                        } else {
                            this.is_active = false
                        }

                        delete this.customer.extras
                        delete this.customer.region_code
                        delete this.customer.region_name
                        delete this.customer.province_code
                        delete this.customer.province_name
                        delete this.customer.city_code
                        delete this.customer.city_name
                        delete this.customer.barangay_code
                        delete this.customer.barangay_name

                        var customerTypes = await HTTPRequest.getRequest(this.endPoint + "customer_types?id=" + this.customer.customer_type , null, null)
                        this.customerTypes = customerTypes.data
                        var paymentTerms = await HTTPRequest.getRequest(this.endPoint + "payment_terms?id=" + this.customer.payment_term , null, null)
                        this.paymentTerms = paymentTerms.data
                        var wtaxCodes = await HTTPRequest.getRequest(this.endPoint + "accounts/wtax_codes?wtax_code="+this.customer.wtax_code , null, null)
                        this.wtaxCodes = wtaxCodes
                        var countries = await HTTPRequest.getRequest(this.endPoint + "countries?id=" + this.customer.address.country_id , null, null)
                        this.countries = countries.data

                        if(this.customer.address.province_code != null)
                            await this.changeAddress('provinces', 1);
                        if(this.customer.address.city_code != null)
                            await this.changeAddress('cities', 1);
                        if(this.customer.address.barangay_code != null)
                            await this.changeAddress('barangays', 1);
                
                    } else {
                        this.errors = customer_data["error"].split(",");
                    }
                }
            }
            
        this.dynamicFormKey++;
        this.spinning = false;
    },
    watch: {
        current: async function(){
            // if (!this.showSensitiveInfo) {
            //     this.customer_data.identification = {type: "1"}
            // }
        },
        is_active: function() {
            if(this.is_active == false){
                this.customer.status = 'I'
            } else {
                this.customer.status = 'A'
            }
        },
    },
    methods: {
        async done(){
            if(this.profileId > 0){
                await this.update()
            } else {
                await this.create()
            }
        },
        formatMyNumber(number, decimal) {
            var splitNum;
            number = Math.abs(number);
            number = number.toFixed(decimal);
            splitNum = number.split('.');
            splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return splitNum.join(".");
        },
        disabledDate(current) {
        // Can not select days before today and today
        return current && current > moment().endOf('day');
        },
        isJsonString(str) {
            try {
                var json = JSON.parse(str);
                return (typeof json === 'object');
            } catch (e) {
                return false;
            }
        },
        onChange(current) {
          this.current = current;
        },
        validateForm(){
                this.errors = [];
                this.errors.push(ValidateField.charMinAndMax('Code', this.customer.code, 0, 30));
                //this.errors.push(ValidateField.required('First Name', this.customer.first_name));
                this.errors.push(ValidateField.alphanumericWithSpace('First Name', this.customer.first_name));
                this.errors.push(ValidateField.charMinAndMax('First Name', this.customer.first_name, 0, 70));
                //this.errors.push(ValidateField.required('Last Name', this.customer.last_name));
                this.errors.push(ValidateField.alphanumericWithSpace('Middle Name', this.customer.middle_name));
                this.errors.push(ValidateField.charMinAndMax('Middle Name', this.customer.middle_name, 0, 30));
                this.errors.push(ValidateField.alphanumericWithSpace('Last Name', this.customer.last_name));
                this.errors.push(ValidateField.charMinAndMax('Last Name', this.customer.last_name, 0, 30));
                this.errors.push(ValidateField.phoneNumberFormat('Phone', this.customer.telephone));
                this.errors.push(ValidateField.charMinAndMax('Phone', this.customer.telephone, 0, 30));
                this.errors.push(ValidateField.phoneNumberFormat('Fax', this.customer.fax));
                this.errors.push(ValidateField.charMinAndMax('Fax', this.customer.fax, 0, 30));
                if(this.customer.email != null && this.customer.email != ""){
                    this.errors.push(ValidateField.emailFormat('Email', this.customer.email));
                }
                this.errors.push(ValidateField.required('WTax Code', this.customer.wtax_code, 0, 30));
                this.errors.push(ValidateField.charMinAndMax('Email', this.customer.email, 0, 30));
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
        async handleWtaxesSearch(value){
            this.fetching = true;
            if(value == undefined)
                this.wtaxCodes = await HTTPRequest.getRequest(this.endPoint + "accounts/wtax_codes" , null, null)
            else
                this.wtaxCodes = await HTTPRequest.getRequest(this.endPoint + "accounts/wtax_codes?wtax_code=" + value , null, null)

            //this.wtaxCodes = this.paymentTerms.data
            this.fetching = false;
        },
        async handlePaymentTermSearch(value){
            this.fetching = true;
            if(value == undefined)
                this.paymentTerms = await HTTPRequest.getRequest(this.endPoint + "payment_terms" , null, null)
            else
                this.paymentTerms = await HTTPRequest.getRequest(this.endPoint + "payment_terms?name=" + value , null, null)

            this.paymentTerms = this.paymentTerms.data
            this.fetching = false;
        },
        async handleCountrySearch(value){
            this.fetching = true;
            if(value == undefined)
                this.countries = await HTTPRequest.getRequest(this.endPoint + "countries" , null, null)
            else
                this.countries = await HTTPRequest.getRequest(this.endPoint + "countries?name=" + value , null, null)

            this.countries = this.countries.data
            this.fetching = false;
        },
        async handleCusTypeSearch(value){
            this.fetching = true;
            if(value == undefined)
                this.customerTypes = await HTTPRequest.getRequest(this.endPoint + "customer_types" , null, null)
            else
                this.customerTypes = await HTTPRequest.getRequest(this.endPoint + "customer_types?name=" + value , null, null)

            this.customerTypes = this.customerTypes.data
            this.fetching = false;
        },
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        },
        sort(data){
            data.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        },
        update: async function () {
            if(!this.validateForm()) {
                if (this.dynamicFormErrors.length == 0){
                    this.spinning = true;
                    var address = this.customer.address
                    delete this.customer['address']
                    this.customer['credit_limit'] = this.customer['credit_limit'].replace(',','');
                    this.customer['credit_balance'] = this.customer['credit_balance'].replace(',','');
                    Object.assign(this.customer, address)
                    var customerPayload = { customer: this.customer }
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'b2b_customers/' + this.profileId, null, customerPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                    this.spinning = false;
                }else{
                    this.errors = this.dynamicFormErrors
                }
            }
        },
        create: async function () {
            if(!this.validateForm()) {
                if (this.dynamicFormErrors.length == 0){
                    this.spinning = true;
                    var address = this.customer.address
                    //delete this.customer['address']
                    Object.assign(this.customer, address)
                    var customerPayload = { customer: this.customer }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'b2b_customers', null, customerPayload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                    this.spinning = false;
                }else{
                    this.errors = this.dynamicFormErrors
                }
            }
        },
        updateSettings(newFormSettings, settingsGrouping, errors){
          var formSettingsCopy = this.customer
          var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
          this.formErrors = errors

          if(this.customFormMode == 3) {
              this.dynamicFormErrors = errors
              this.errors = errors
          }
          this.customer = mergedHash

        },
        changeAddress: async function(list, fresh = 0){
            this.addressLoading = true
            switch(list) {
            case 'provinces':
                if(this.customer.address.country_id != null){
                    await this.getList(list, this.customer.address.country_id, 'country')
                    this.sort(this.response)
                    this.provinces = this.response
                    this.addressOptions = {
                        provinces: this.provinces,
                        cities: [],
                        barangays: []
                    }

                    if(fresh == 0){
                        Object.assign(this.customer.address, {
                            province_code: null,
                            province_name: "",
                            city_code: null,
                            city_name: "",
                            barangay_code: null,
                            barangay_name: ""
                        });
                    } else {
                        Object.assign(this.customer.address, {
                            province_code: this.provinces.find(x => x.id === parseInt(this.customer.address.province_code))['id'],
                            province_name: this.provinces.find(x => x.id === parseInt(this.customer.address.province_code))['name']
                        })
                    }
                }
                break;
            case 'cities':
                if(this.customer.address.country_id != null && this.customer.address.province_code != null){
                    await this.getList(list, this.customer.address.province_code, 'province')
                    this.sort(this.response)
                    this.cities = this.response
                    this.addressOptions = {
                        provinces: this.provinces,
                        cities: this.cities,
                        barangays: []
                    }

                    if(fresh == 0){
                        Object.assign(this.customer.address, {
                            province_code: this.provinces.find(x => x.id === parseInt(this.customer.address.province_code))['id'],
                            province_name: this.provinces.find(x => x.id === parseInt(this.customer.address.province_code))['name'],
                            city_code: null,
                            city_name: "",
                            barangay_code: null,
                            barangay_name: ""
                        });
                    } else {
                        Object.assign(this.customer.address, {
                            city_code: this.cities.find(x => x.id === parseInt(this.customer.address.city_code))['id'],
                            city_name: this.cities.find(x => x.id === parseInt(this.customer.address.city_code))['name']
                        })
                    }
                }
                break;
            case 'barangays':
                if(this.customer.address.country_id != null && this.customer.address.province_code != null && this.customer.address.city_code != null){
                    await this.getList(list, this.customer.address.city_code, 'city')
                    this.sort(this.response)
                    this.barangays = this.response
                    this.addressOptions = {
                        provinces: this.provinces,
                        cities: this.cities,
                        barangays: this.barangays
                    }

                    if(fresh == 0){
                        Object.assign(this.customer.address, {
                            city_code: this.cities.find(x => x.id === parseInt(this.customer.address.city_code))['id'],
                            city_name: this.cities.find(x => x.id === parseInt(this.customer.address.city_code))['name'],
                            barangay_code: null,
                            barangay_name: ""
                        });
                    } else {
                        Object.assign(this.customer.address, {
                            barangay_code: this.barangays.find(x => x.id === parseInt(this.customer.address.barangay_code))['id']
                        })
                    }
                }
                break;
            default:
                if(this.customer.address.barangay_code != null){
                    Object.assign(this.customer.address, {
                        barangay_name: this.addressOptions.barangays.find(x => x.id === this.customer.address.barangay_code).name
                    })
                }

                //Get Zip Code
                // await axios({
                //     method: 'GET',
                //     url: 'https://s.boxme.asia/api/v2/sellers/locations/' + this.customer.address.country_id + '/zipcodes?province_id=' + this.customer.address.province_code + '&district_id=' + this.customer.address.city_code
                // })
                // .then(function (response) {
                //     let response_data = response.data
                //     console.log('^^^^^^^^^^^^^^^^^^^^')
                //     console.log(response_data)
                //     console.log('^^^^^^^^^^^^^^^^^^^^')
                // }).catch(err => {
                //     component_x.response = []
                // })
                }

            this.addressLoading = false
        },
        getList: async function(list, parent_code, parentList){
            component_x = this;

            let code
            if (parent_code == null){
                code = ''
            } else if(parentList == 'country') {
                code = 'get_box_me_' + list + '?' + parentList + '=' + parent_code
            } else if(parentList == 'province') {
                code = 'get_box_me_districts?country=' + this.customer.address.country_id + '&' + parentList + '_id=' + parent_code
            } else if(parentList == 'city') {
                code = 'get_box_me_sub_districts?country=' + this.customer.address.country_id + '&province_id=' + this.customer.address.province_code + '&district_id=' + parent_code
            }

            const result = await HTTPRequest.getRequest(this.endPoint + 'box_me_locations/' + code  , null)
            if(result.length > 0){
                this.errors = [];
                let response_data = result
                let response_array = []
                for (let index = 0; index < response_data.length; index++) {
                    let row_set = response_data[index]
                    response_array.push({
                        id: row_set.id,
                        name: row_set.name
                    })
                }
                component_x.response = response_array
            } else {
                this.errors.push('No '+ list + ' for the selected ' + parentList + '.');
            }
                
        },

    }

}
</script>>
